// src/components/AddressPicker.js

import React, { useRef, useEffect } from "react";

export default function AddressPicker({
  value,
  onChange,
  onSelect,
  disabled
}) {

  const inputRef = useRef(null);
  const autocompleteRef = useRef(null);


  useEffect(() => {

    if (!window.google || !inputRef.current) return;

    autocompleteRef.current =
      new window.google.maps.places.Autocomplete(
        inputRef.current,
        {
          componentRestrictions: { country: "in" },
          fields: ["formatted_address", "geometry"],
        }
      );

    autocompleteRef.current.addListener(
      "place_changed",
      () => {

        const place =
          autocompleteRef.current.getPlace();

        if (!place.geometry) return;

        const address =
          place.formatted_address;

        const lat =
          place.geometry.location.lat();

        const lng =
          place.geometry.location.lng();

        inputRef.current.value = address;

        onSelect({
          address,
          lat,
          lng
        });

      }
    );

  }, []);


  useEffect(() => {

    if (inputRef.current) {

      inputRef.current.value =
        value || "";

    }

  }, [value]);


  return (

    <input
      ref={inputRef}
      disabled={disabled}
      onChange={(e) =>
        onChange(e.target.value)
      }
      placeholder="Enter address"
      style={{
        width: "100%",
        padding: 10,
        borderRadius: 8,
        border: "1px solid #ccc"
      }}
    />

  );

}
